<template>
  <b-container fluid>
    <b-row>
      <b-col md="3">
        <!-- <iq-card class="calender-small">
          <template v-slot:body>
            <flat-pickr :config="config" value="" class="d-none"/>
          </template>
        </iq-card> -->
        <iq-card v-if="viewClassificationComp">
          <template v-slot:headerTitle>
            <h4 class="card-title ">Classification</h4>
          </template>
          <template v-slot:headerAction>
            <a href="#" @click="triggerClassificationModal('Add')"><i class="fa fa-plus  mr-0" aria-hidden="true" /></a>
          </template>
          <template v-slot:body>
            <ul class="m-0 p-0 job-classification" style="height: 200px; overflow-y: scroll;">
              <li class="" v-for="(d, i) in classificationList" :key="`classification-${i}`"><a href="#" @click="triggerClassificationModal('Edit', d)"><i class="ri-check-line mr-2" :style="`background-color: ${d.color}`" />{{ d?.name }}</a> <i class="las la-trash float-right" @click="deleteClassificationData(d?.id)" style="color:red; font-size: 20px; cursor:pointer;"></i></li>
            </ul>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Today's Schedule</h4>
          </template>
          <template v-slot:body>
            <ul class="m-0 p-0 today-schedule" style="height: 200px; overflow-y: scroll;">
              <li class="d-flex" v-for="(d, i) in todayScheduleList" :key="`today-sched-${i}`" style="cursor:pointer" @click="openAppointmentInfo(d)">
                <div class="schedule-icon"><i class="ri-checkbox-blank-circle-fill text-primary" :style="`color: ${d?.color}`" /></div>
                <div class="schedule-text"> <span>{{ d?.isRequiredPatient === 'Y' ? d?.patient_name : d?.title }} <br> <small>{{ d?.note }}</small></span>
                  <span>{{  `${d?.time_start} to ${d?.time_end}`  }}</span></div>
              </li>
            </ul>
          </template>
        </iq-card>
      </b-col>
      <b-col md="9">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Book Appointment</h4>
          </template>
          <template v-slot:headerAction>
            <a href="#" class="btn btn-primary" @click="triggerBookingModal('Add', {})"><i class="ri-add-line mr-2"></i>Book Appointment</a>
          </template>
          <template v-slot:body>
            <FullCalendar :calendarEvents="bookingList" @getEventClickId="getEventClickId($event)" @viewMonthYearChanged="onViewMonthYearChanged"/>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <classificationModal @triggerClassification="triggerClassification" :modalFormAction="modalFormAction" :selectedItem="selectedItem"/>
    <BookingModal ref="bookingModalRC" @triggerBooking="triggerBooking" :classificationList="classificationList" :modalFormAction="modalFormAction" :selectedItem="selectedItem"/>
    <b-modal id="modal-booking-info" ref="modal-booking-info" title="Appointment Info">
      <div class="row">
        <div class="col-12">
          <ul class="list-unstyled">
            <li><b>Classification: </b>{{ selectedItem?.classification_name }}</li>
            <li><b>Title: </b>{{ selectedItem?.title }}</li>
            <li><b>Note: </b>{{ selectedItem?.note }}</li>
            <li><b>Date/Time Start: </b>{{ selectedItem?.dateStart }}</li>
            <li><b>Date/Time end: </b>{{ selectedItem?.dateEnd }}</li>
            <li v-if="selectedItem?.isRequiredPatient === 'Y'"><b>Patient: </b>{{ selectedItem?.patient_name }} [{{selectedItem?.patient_no}}]</li>
          </ul>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-booking-info')">Close</b-button>
        <b-button variant="primary" @click="openUpdateBookingModal(selectedItem)">Update</b-button>
        <b-button variant="danger" @click="cancelBooking(selectedItem)">Delete Booking</b-button>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from '../../../config/pluginInit'
import classificationModal from './CalendarComponents/ClassificationModal.vue'
import BookingModal from './CalendarComponents/BookingModal.vue'
import classification from '../../../services/classification'
import booking from '../../../services/booking'
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  name: 'GoogleCalendar',
  components: { classificationModal, BookingModal },
  data () {
    return {
      modalFormAction: 'Add',
      config: {
        dateFormat: 'Y-m-d',
        inline: true
      },
      viewClassificationComp: false,
      classificationList: [],
      bookingList: [],
      todayScheduleList: [],
      selectedItem: {},
      selectedMonth: null,
      selectedYear: null
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'Auth/userDetails'
    })
  },
  watch: {
    userDetails: _.debounce(function () {
      this.checkAccessOnClassification()
    })
  },
  mounted () {
    xray.index()
    this.triggerClassification()
    this.getAllTodayBookings()

    // initial calendar load - fetch bookings for current month
    const today = new Date()
    const month = today.getMonth() + 1
    const year = today.getFullYear()

    this.triggerBooking(month, year)
    // this.getAllTodaysBooking()
    this.checkAccessOnClassification()
  },
  methods: {
    checkAccessOnClassification () {
      if (this.userDetails?.role) {
       this.viewClassificationComp = (['AD', 'SA']).includes(this.userDetails.role)
      }
    },
    getEventClickId (evt) {
      booking.getBookingDetails(evt)
      .then(({ data }) => {
        if (data.success) {
          this.openAppointmentInfo(data?.data)
        }
      })
      .catch((error) => { console.log(error) })
    },
    openAppointmentInfo (data) {
      this.selectedItem = data
      this.$bvModal.show('modal-booking-info')
    },
    deleteClassificationData (id) {
      classification.deleteClassification(id)
      .then(({ data }) => {
        if (data?.success) {
          this.triggerClassification()
        }
        this.$swal(data?.message)
       })
    },
    getTodaysAppointment () {},
    triggerBookingModal (action = 'Add', item = {}) {
      this.selectedItem = item
      this.modalFormAction = action
      this.$bvModal.show('modal-booking')
    },
    triggerClassificationModal (action = 'Add', item = {}) {
      this.selectedItem = item
      this.modalFormAction = action
      this.$bvModal.show('modal-classification')
    },
    triggerClassification () {
      classification.getAllClassifications()
      .then(({ data }) => {
        if (data?.success) {
          this.classificationList = data.data
        }
      })
      .catch(error => { console.log(error) })

      this.selectedItem = {}
    },
    triggerBooking (month = null, year = null) {
      // Determine default month/year if not provided
      if (!month || !year) {
        const today = new Date()
        month = today.getMonth() + 1
        year = today.getFullYear()
      }

      booking.getBookingsByMonthYear(month, year)
        .then(({ data }) => {
          if (data?.success) {
            // Update calendar events
            this.bookingList = data.data.map(d => ({
              id: d?.id,
              title: `${d?.classification_name} ( ${d?.isRequiredPatient === 'Y' ? d?.patient_name : d?.title} )`,
              start: d?.date_from,
              end: d?.date_to,
              color: d?.color
            }))
          } else {
            this.bookingList = []
            this.todayScheduleList = []
          }
        })
        .catch(error => {
          console.error('Error fetching bookings by month/year:', error)
        })

      this.selectedItem = {}
    },
    onViewMonthYearChanged ({ month, year }) {
      this.selectedMonth = month
      this.selectedYear = year
      this.triggerBooking(month, year)
    },
    getAllTodayBookings () {
      booking.getAllTodaysBooking()
        .then(({ data }) => {
          if (data?.success) {
            console.log('hello')
            this.todayScheduleList = data.data
          }
        })
        .catch(error => { console.log(error) })
    },
    cancelBooking () {
      this.$swal.fire({
          title: 'Are you sure you want to remove this booking?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No'
      }).then((result) => {
        if (result.isConfirmed) {
          booking.deleteBooking(this.selectedItem.id)
          .then(response => {
            if (response.data.success) {
              let month = this.selectedMonth
              let year = this.selectedYear

              if (this.selectedYear === null && this.selectedYear === null) {
                const today = new Date()
                month = today.getMonth() + 1
                year = today.getFullYear()
              }
              this.triggerBooking(month, year)
              this.getTodaysAppointment()
              this.$bvModal.hide('modal-booking-info')
            }
            this.$swal(response?.data?.message)
          })
        }
      })
    },
    openUpdateBookingModal (booking) {
      // Set the selected patient if exists
      if (booking.id) {
        this.selectedPatient = {
          id: booking.id,
          first_name: booking.first_name,
          last_name: booking.last_name,
          patient_no: booking.patient_no,
          patient_id: booking.patient_id
        }
      } else {
        this.selectedPatient = null
      }

      // Prefill the booking form data
      this.$nextTick(() => {
        const modal = this.$refs.bookingModalRC
        modal.modalFormAction = 'Update' // change title
        modal.formData = {
          id: booking.id,
          classification_id: 1,
          patient_id: booking.patient_id,
          title: booking.title,
          note: booking.note,
          date_from: booking.date_from,
          date_to: booking.date_to
        }

        this.$bvModal.hide('modal-booking-info')
        this.$bvModal.show('modal-booking')
      })
    }
  }
}
</script>
